import { ConfigProvider, Spin } from 'antd';
import { Route, Routes } from 'react-router-dom';
import { themeConfig } from './utils/antdThemeConfig';
import { ContextProvider } from './context/Context';
import PrivateLayout from './components/Layout';
import useDynamicRoutes from './routes';

function App() {
	const routes = useDynamicRoutes();

	return (
		<div>
			<ConfigProvider theme={themeConfig}>
				<ContextProvider>
					{routes.length === 0 ? (
						<div className="loading-wrapper">
							<Spin size="large" />
						</div>
					) : (
						<Routes>
							<Route element={<PrivateLayout />}>
								{routes.map((r, i) => (
									<Route key={i} path={r.path} element={r.element} />
								))}
							</Route>
						</Routes>
					)}
				</ContextProvider>
			</ConfigProvider>
		</div>
	);
}

export default App;
